module.exports = __webpack_public_path__ + "img/nihcoba.f5f53108.svg";